import * as React from 'react';
import Icon from './icon';

export interface PaginationProps {
    currentPage: number;
    total: number;
    pageSize: number;
    onChange: (pageIndex: number) => void;
}

export interface PaginationState {
}

export default class Pagination extends React.Component<PaginationProps, PaginationState> {
  constructor(props: PaginationProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    const count = this.props.total;
    const pages: React.ReactNode[] = [];

    let i = 1;
    for (i = 1; i <= count; i++){
        const p = i;
        pages.push(<a key={"page-index" + i} className={`pagination-index ${i == this.props.currentPage? 'selected': ''}`} onClick={() => this.props.onChange(p)}>{i}</a>);
    }

    const canPrev = this.props.currentPage > 1;
    const canNext = this.props.currentPage < count;
    return (
      <div className="pagination">
        {canPrev && this.props.total > 0 && <div onClick={() => { this.props.onChange(this.props.currentPage - 1) }} className={`left-page ${this.props.currentPage == 1? 'disabled': ''}`}>
          {/*<img src='static/images/caret-left.svg'/>*/}
          <Icon type='caret-left'/>
          
        </div>}
        {pages}
        {canNext && <div onClick={() => { this.props.onChange(this.props.currentPage + 1) }} className={`right-page ${this.props.currentPage > count - 1? 'disabled': ''}`}>
          <Icon type='caret-right'/>
          {/*<img src='static/images/caret.svg'/>*/}
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/pagination.tsx